import * as React                      from 'react';

import { Dialog                      } from 'src/components/common/dialog';
import { IconButton                  } from 'src/components/common/icon-button';
import { DateLabel                   } from 'src/components/common/date-label';

import { Status,
         StatusVariants              } from 'src/components/features/main/inspection-list/status';
import { Container,
         Caption,
         DateBlock,
         ContentBlock,
         Label,
         Content,
         Close,
         CloseOutlineVectorBig,
         RemarkStatusDialogVariants,
         remarkstatusdialog_variants } from 'src/components/features/main/inspection-list/remark-status-dialog/ui';


import * as types                      from 'src/services/api/types';

import { useAppSelector, 
         useAppDispatch,
         storeApi                    } from 'src/store';



type Props = {
  variant: RemarkStatusDialogVariants;
}
export const RemarkStatusDialog: React.FC<Props> = ({ variant }) => {
  const lookAndFeel = remarkstatusdialog_variants.get(variant)!;
  const dispatch = useAppDispatch();

  const isOpened = useAppSelector(storeApi.main.inspectionList.selectors.selectRemarkStatusOpened);
  const inspection = useAppSelector(storeApi.main.inspectionList.selectors.selectBottomSheetContext);

  if (inspection === null)
  {
    return null;
  }

  return (
    <Dialog variant = { lookAndFeel.dialogVariant } isOpened={isOpened}>
      <Container lookAndFeel = { lookAndFeel }>
        <Close lookAndFeel = { lookAndFeel }>
          <IconButton
            variant = { lookAndFeel.closeButtonVariant }
            isTapAllowed
            onTap = { () => dispatch(storeApi.main.inspectionList.actions.remarkStatusOpenedChanged(false)) }
          >
            <CloseOutlineVectorBig />
          </IconButton>
        </Close>
        <Caption lookAndFeel = { lookAndFeel }>
          Статус осмотра
        </Caption>
        <DateBlock lookAndFeel = { lookAndFeel }>
          <DateLabel variant = { lookAndFeel.datelabelVariant } date = { new Date(inspection.status.timestamp) } />
          <Status variant = { getStatusVariant(inspection.status.code) } label = { inspection.status.title } />
        </DateBlock>
        {inspection.status.fio !== null && inspection.status.fio !== '' && (
          <ContentBlock lookAndFeel = { lookAndFeel }>
            <Label lookAndFeel = { lookAndFeel }>
              Инициатор
            </Label>
            <Content lookAndFeel = { lookAndFeel }>
              {inspection.status.fio}
            </Content>
          </ContentBlock>
        )}
        {inspection.status.note !== null && inspection.status.note !== '' && (
          <ContentBlock lookAndFeel = { lookAndFeel }>
            <Label lookAndFeel = { lookAndFeel }>
              Примечание
            </Label>
            <Content lookAndFeel = { lookAndFeel }>
              {inspection.status.note}
            </Content>
          </ContentBlock>
        )}
       </Container>
    </Dialog>
  );
};

const getStatusVariant = (status: types.inspection.InspectionStatusCode): StatusVariants => {
  const {
    AWAITING_CONFIRMATION,
    AWAITING_REVIEW,
    AWAITING_VERIFICATION,
    TAKE_TO_WORK,
    COMPLETED,
    INTERNAL,
    RETURN_FOR_REVISION,
    REVOCATION,
    ERROR,
    DRAFT,
    NO_TRANS_DRAFT,
    NO_TRANS_ERROR,
    NO_TRANS_COMPLETED,
    INTERNAL_NO_TRANS_COMPLETED,
  } = types.inspection.InspectionStatusCode;

  switch (status)
  {
    case AWAITING_CONFIRMATION:
    case AWAITING_REVIEW:
    case AWAITING_VERIFICATION:
      return 'bluefill';
    case TAKE_TO_WORK:
    case COMPLETED:
    case INTERNAL:
      return 'blueoutline';
    case RETURN_FOR_REVISION:
    case REVOCATION:
      return 'redoutline';
    case ERROR:
    case NO_TRANS_DRAFT:
    case NO_TRANS_ERROR:
    case NO_TRANS_COMPLETED:
    case INTERNAL_NO_TRANS_COMPLETED:
      return 'redfill';
    case DRAFT:
      return 'gray';
    default:
      return 'gray';
  }
}
